var common = common || {};

common._getServlet = common._getServlet || function() {
  return window.location.pathname.indexOf('/cs/')===0 ? '/cs' : '/ss';
};

common.months = ['All', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August',
      'September', 'October', 'November', 'December'];

common.getYears = function (endYear) {
  var years = ['All'];
  var startYear = new Date().getFullYear();
  while (startYear>=endYear) {
    years.push(startYear--);
  }
  return years;
};

common.findNews = function($scope, lodash, SearchService) {
  $scope.types.forEach(function(it) { $scope.data[it] = {}; $scope.options[it] = {};});

  $scope.loadMore = function(type) {
    $scope.options[type].append = true;
    $scope.options[type].start += $scope.options[type].max;
    SearchService.findNews($scope.options[type], lodash.assign({}, $scope.filters, { 'type': type }), $scope.data[type]);
  };

  $scope.updateNews = function () {
    if ($scope.filters.type !== 'All') {
      $scope.options[$scope.filters.type].start = 0;
      SearchService.findNews($scope.options[$scope.filters.type], $scope.filters, $scope.data[$scope.filters.type]);
    } else {
      $scope.types.forEach(function(it){
        if (it === 'All') {
          return;
        }
        $scope.options[it].start = 0;
        SearchService.findNews($scope.options[it], lodash.assign({}, $scope.filters, { 'type': it }), $scope.data[it]);
      });
    }
  };

  $scope.$watchGroup(['filters.year','filters.month'], $scope.updateNews);
};
/*************************************************************************************************
 * THESE ARE CONTROLLERS FOR ALL PAGINATED (SEARCH) FORMS
 ************************************************************************************************/
angular.module('app.controllers.paginated_forms', ['ngLodash', 'ngSanitize', 'ui.bootstrap'])

/*********************************** Controller for Referral Search  *****************************/

  .controller("ReferralSearchController", function ($rootScope, $scope, $log, $location, $http) {
    $scope.RSCsubmitted = false;
    $scope.mobile = "0";
    $scope.area = "0";
    $scope.appliance = 0;
    $scope.referraltype = "R";
    $scope.resetForm = function(){
      if ($scope.RSCsubmitted) {
         $scope.allgood = false;
         $scope.referraltype = "R";
         $scope.location = "0";
         $scope.area = "0";
         $scope.appliance = "0";
         $scope.service = "0";
         $scope.mobile = "0";
         $scope.agree = false;
         $scope.haslocation = $scope.hasarea = $scope.hasappliance = $scope.hasservice = false;
      }
    };

    $scope.isAllGood = function() {
      if ($scope.location != "0" && $scope.area != "0" && $scope.area !== "" && $scope.appliance != "0" && $scope.service != "0") {
        if ( !(location == '24' || location == '21') || (mobile == '1' || mobile == '2') )
        return true;
      }
        return false;
    };

    /* NOTE This type of call would be made if the backend returns all dropdown data together *
    $scope.getAllLocationDependencies = function () {
      var optionurl = "/swgasws/resources/form/availableOptions/" + $scope.location;
      $http.get(optionurl).success(function (optiondata) {
        $scope.availableareas = optiondata.availableareas;
        $scope.availableappliances = optiondata.availableappliances;
        $scope.availableservices = optiondata.availableservices;
      }).error(function (optiondata) {
        $scope.availableareas = {"Select a City/Area": "0"};
        $scope.availableappliances = {"Select Appliance/Equipment": "0"};
        $scope.availableservices = {"Select a Service": "0"};
        $log.debug("Failure:" + optiondata.toString());
      });
    };
    */

    $scope.locationchange = function () {
      $scope.allgood = $scope.isAllGood();
      $scope.haslocation = true;
      $scope.availableareas = [{"id": "0", "name": "Select a City/Area"}];
      $scope.area = "0";
      $scope.availableappliances = [{"id": "0", "name": "Select Appliance/Equipment"}];
      $scope.appliance = "0";
      $scope.availableservices = [{"id": "0", "name": "Select a Service"}];
      $scope.service = "0";

      var areaurl = "/swgasws/resources/form/availableAreas/" + $scope.location;
      $http.get(areaurl).success(function (areadata) {
        $scope.availableareas = areadata;
      }).error(function (areadata) {
        $scope.availableareas = [{"id": "", "name": "No Areas Selected"}];
        $log.debug("Failure:" + areadata.toString());
      });
    };

    $scope.areachange = function () {
      $scope.allgood = $scope.isAllGood();
      $scope.hasarea = true;
      var applianceurl = "/swgasws/resources/form/availableAppliances/" + $scope.area;
      $http.get(applianceurl).success(function (appliancedata) {
        $scope.availableappliances = appliancedata;
        $scope.allgood = $scope.isAllGood();
      }).error(function (appliancedata) {
        $scope.availableappliances = [{"id": "0", "name": "Select Appliance/Equipment"}];
        $log.debug("Failure:" + appliancedata.toString());
      });
    };

    $scope.appliancechange = function () {
      $scope.allgood = $scope.isAllGood();
      $scope.hasappliance = true;
      var serviceurl = "/swgasws/resources/form/availableServices/" + $scope.appliance;
      $scope.availableservices = null;
      $http.get(serviceurl).success(function (servicedata) {
        $scope.availableservices = servicedata;
        $scope.allgood = $scope.isAllGood();
      }).error(function (servicedata) {
        $scope.availableservices = [{"id": "0", "name": "Select a Service"}];
        $log.debug("Failure:" + servicedata.toString());
      });
    };

    $scope.servicechange = function () {
      $scope.allgood = $scope.isAllGood();
      $scope.hasservice = true;
    };

    $scope.form_name = "Referral Search";
    $scope.form_info = [
      "If you have an emergency, please do not use this form. Call 602-271-4277 or 800-528-4277 if you have an emergency" +
      " or safety related issue."
    ];
    $scope.submit = function () {
      window.location = "/en/contractor-referrals-results?referraltype=" + $scope.referraltype + "&location=" + $scope.location + "&area=" + $scope.area + "&appliance=" + $scope.appliance + "&service=" + $scope.service + "&mobile=" + $scope.mobile;
     // alert("/en/contractor-referrals-results?referraltype=" + $scope.referraltype + "&location=" + $scope.location + "&area=" + $scope.area + "&appliance=" + $scope.appliance + "&service=" + $scope.service + "&mobile=" + $scope.mobile);
      $scope.RSCsubmitted = true;
      $scope.resetForm();
    };

  })

/*********************************** Controller for Referral Search Results *****************************/

  .controller("ReferralSearchResultsController", function ($rootScope, $scope, $log, $http) {

   $scope.statmessage="Please wait while we process your referral search request.....";
   
    function getParameterByName(name) {
      name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);

      return null === results ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }

    var validmobile = "1";
    if (getParameterByName("mobile")) {
      validmobile = getParameterByName("mobile");
    }

    var dataObj = {
      referraltype: getParameterByName("referraltype"),
      location: getParameterByName("location"),
      area: getParameterByName("area"),
      appliance: getParameterByName("appliance"),
      service: getParameterByName("service"),
      mobile: validmobile
    };

    $scope.returnToSearch = function () {
      window.location = "/en/contractor-referrals";
    };

    $scope.newValue = function (value) {
      $scope.availableservices = [{"id": "0", "name": "Select a Service"}];

      var url = "/swgasws/resources/form/referrals/add?" + "referraltype=" + getParameterByName("referraltype") + "&location=" + getParameterByName("location") + "&area=" + getParameterByName("area") + "&appliance=" + getParameterByName("appliance") + "&service=" + getParameterByName("service") + "&mobile=" + getParameterByName("mobile");
      $http.post(url).success(function (data, status, headers, config) {
        $scope.results = data;
       // console.log(data);
        if (data.length === 0) {
           $scope.statmessage="No referrals were found based upon your criteria. Please contact a Southwest Gas Energy Specialist at 800-OK-GAS-OK (800-654-2765) or use a licensed contractor of your choice. It is recommended to contact a few licensed contractors and get written estimates. Please be sure to ask the contractor/appliance dealer if it's a free estimate, what their services include and the fee for these services prior to scheduling an appointment.";
        }
      }).error(function (data, status, headers, config) {
        $scope.statmessage="Your inquiry is unavailable due to maintenance.  We apologize for the inconvenience at this time. Please try again later.";
        $log.debug("Failure:" + data.toString());
      });
    };
  })

/**************************************************************************** Controller for News Releases  *****/
  .controller("CorporateNewsController", function ($scope, lodash, SearchService) {
    lodash.assign($scope, {
      'filters': { 'year': 'All', 'month': 0, 'type': 'All', 'subtype': 'NewsRelease' },
      'months': common.months,
      'years': common.getYears(2014),
      'types': ['All', 'Corporate', 'Dividend', 'Arizona', 'California', 'Nevada'],
      'data': {},
      'options': {}
    });
    common.findNews($scope, lodash, SearchService);
  })
  .controller("InTheNewsController", function ($scope, lodash, SearchService) {
    // Setting types and type to dummy value 'InTheNews' to reuse the findNews function
    lodash.assign($scope, {
      'filters': { 'year': 'All', 'month': 0, 'type': 'InTheNews' },
      'months': common.months,
      'years': common.getYears(2010),
      'data': {},
      'types': ['InTheNews'],
      'options': {}
    });
    common.findNews($scope, lodash, SearchService);
  })
  .controller("NewsEventsController", function ($scope, $timeout, lodash, SearchService) {
    var stateCodes = { 'Arizona': 'AZ', 'California': 'CA', 'Nevada': 'NV' };
    lodash.assign($scope, {
      'types': ['Arizona', 'California', 'Nevada'],
      'data': {},
      'options': {}
    });

    $scope.types.forEach(function(it) { $scope.data[it] = {}; $scope.options[it] = {};});

    $scope.loadMore = function(type) {
      $scope.options[type].append = true;
      $scope.options[type].start += $scope.options[type].max;
      SearchService.findEvents($scope.options[type], lodash.assign({}, $scope.filters, { 'type': stateCodes[type] }), $scope.data[type]);
    };

    $timeout(function () {
      $scope.types.forEach(function(it){
        SearchService.findEvents($scope.options[it], lodash.assign({}, $scope.filters, { 'type': stateCodes[it] }), $scope.data[it]);
      });
    });
  })
  .controller("EventsCarouselController", function ($scope, $timeout, $animate, lodash, SearchService) {
    lodash.assign($scope, { 'data': {}, 'options': { 'max': 10 } });
    SearchService.findEvents($scope.options, {}, $scope.data);
    $timeout(function () {
      $animate.enabled(true, angular.element(".carousel"));
    });
  })
  .controller("NewsCarouselController", function ($scope, $timeout, $animate, lodash, SearchService) {
   lodash.assign($scope, {
      'filters': {},
      'types': ['All', 'Corporate', 'Dividend', 'Arizona', 'California', 'Nevada'],
      'data': {},
      'options': {}
    });
    SearchService.findNews(
      lodash.assign({}, $scope.options, { 'max': 10 }), 
      lodash.assign({}, $scope.filters, { 'year': 'All', 'month': 0, 'type': 'All', 'subtype': 'NewsRelease' }), 
      $scope.data);
    
    $timeout(function () {
      $animate.enabled(true, angular.element(".carousel"));
    });
  })
    .controller("EventsCarouselController", function ($scope, $timeout, $animate, lodash, SearchService) {
    lodash.assign($scope, { 'data': {}, 'options': { 'max': 10 } });
    SearchService.findEvents($scope.options, {}, $scope.data);
    $timeout(function () {
      $animate.enabled(true, angular.element(".carousel"));
    });
  })
  .controller("TwitterFeedController", function ($scope, $timeout, $animate, lodash, SearchService) {
   lodash.assign($scope, {
      'data': {},
      'options': {}
    });
    SearchService.pullTweets($scope.data);
      
    $timeout(function () {
      $animate.enabled(true, angular.element(".carousel"));
    });
  })
  .controller("NewsletterController", function ($scope, $timeout, lodash, SearchService) {
    var cb = function() { 
      $scope.data.currentIssue = lodash.first($scope.data.items);
      $scope.data.pastIssues = $scope.data.items.slice(1,$scope.data.items.length);
    };

    lodash.assign($scope, { 'data': {}, 'options': {} });

    $scope.loadMore = function(type) { 
      $scope.options.append = true;
      $scope.options.start += $scope.options.max;
      SearchService.findNewsletters($scope.options, $scope.data).then(cb);

    };

    $timeout(function() {
      SearchService.findNewsletters($scope.options, $scope.data).then(cb);
    });
  })
  .controller("RebatePromotionSearchController", function ($scope, $http, $log, $timeout) {
    $scope.init = function () {
      $scope.loading = true;
      $scope.append = false;
      $scope.start = 0;
      $scope.max = 10;
      $scope.rebates = [];
      $scope.refineMenuOpen = false;
      $scope.states = ['AZ', 'CA', 'NV'];
      $scope.rebateType = 'All';
      $scope.products = ['Appliance Connection', 'Cooking', 'Custom Rebate', 'Dishwasher', 'Energy Audit',
          'Fireplace', 'Heating-Cooling', 'Homes Program', 'Outdoor Appliances', 'Solar Water Heating', 'Washer-Dryer',
          'Water Heating', 'Weatherization'];
      $scope.whoAmI = 'Homeowner';
      
      $scope.selectedProducts = {};
      $scope.numSelectedProducts = $scope.products.length;
      $scope.products.forEach(function(cat){
        $scope.selectedProducts[cat] = true;
      });
      $scope.selectedProducts.selectall = true;

      $scope.selectedStates = {'NV': true,'AZ': true,'CA': true};
      
      
    };

    $scope.toggleProduct = function(product) {
      var all = true;
      if ($scope.selectedProducts[product]) {
        $scope.numSelectedProducts++;
      } else {
        $scope.numSelectedProducts--;
      }
      $scope.selectedProducts.selectall =  ($scope.numSelectedProducts == $scope.products.length);

      $scope.updateRebates();
    };

    $scope.toggleAllProducts = function () {
      $scope.products.forEach(function(x) {
        $scope.selectedProducts[x] = $scope.selectedProducts.selectall;
      });
      $scope.numSelectedProducts = $scope.selectedProducts.selectall ? $scope.products.length : 0;
      $scope.updateRebates();
    };

    $scope.loadMore = function () {
      $scope.start += $scope.max;
      $scope.append = true;
      $scope.updateRebates();
    };

    $scope.refine = function (val) {
      $scope.refineMenuOpen = val;
      $log.debug('RebatesAndPromotionsController(): $scope.refineMenuOpen', $scope.refineMenuOpen);
    };

    $scope.updateRebates = function () {
      $scope.loading = true;
      var url = _getServlet() + "/Satellite?pagename=swg/service/search" +
        "&max=" + $scope.max +
        "&start=" + $scope.start +
        "&d=" +
        "&index=swgArticle" +
        "&subtype=Rebate" +
        "&sort=enddate:true;startdate:true;updateddate:true" +
        "&q_WhoAmI=" + $scope.whoAmI +
        "&q_RebateType=" + $scope.rebateType;

      var temp = [];
      if ($scope.numSelectedProducts===0) {
        url += "&q_RebateCategory=NONE";
      } else {
        $scope.products.forEach(function(x) {
          if ($scope.selectedProducts[x]) {
            temp.push(x);
          }
        });
        url += "&q_RebateCategory=" + temp.join(',');
      }

      temp = [];
      $scope.states.forEach(function(x) {
        if ($scope.selectedStates[x]) {
          temp.push(x);
        }
        
      });  
      url += "&q_State=" + ((temp.length===0) ? "NONE" : temp.join(','));

      $http.get(url).success(function (data, status) {
        $scope.found = data.results.count;
        $scope.hasMore = $scope.start + $scope.max < $scope.found;
        $scope.rebates = $scope.append ? $scope.rebates.concat(data.results.items) : data.results.items;
        if (!$scope.append) {
          $scope.start = 0;
        }
        $scope.loading = false;
        $scope.append = false;
      }).error(function (data, status) {
        $log.error("Failure:" + data.toString());
      });
    };

    $timeout(function(){
      $scope.updateRebates();
      $scope.loading = false;
    });

    $scope.$watchGroup(['whoAmI','rebateType'], function () {
      if ($scope.loading) {
        return;
      }
      $scope.updateRebates();
    });
  })


  /************************************************************************************ Controller for Newsletter Demo  *****/
  .controller("GH_NLController", function ($scope, $http) {
    $scope.currentIssue = {
      'pic': 'images/news-and-events/newsletter.jpg"',
      'date': 'January 30, 2015',
      'title': "Comsectetur Adipiscing Elit, Ipsm Lorem",
      'content': "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Aenean euismod bibendum laoreet. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet."
    };

    $scope.pastIssues = [
      {'date': 'December, 2014', 'title': "One size fits all"}
      , {'date': 'November, 2014', 'title': "The main ingredient to your perfect meal"}
      , {'date': 'October, 2014', 'title': "Natural gas water heaters - which is right for you?"}
      , {'date': 'September, 2014', 'title': "Gentle on fabrics, gentle on the environment"}
    ];

  });
